import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

/** Fin/SOB rows the dashboard is scoped to: the selected offering's rows, or every
 *  row when no offering is selected (the all-offerings rollup).
 *
 *  Scoping only. The payload is long format, so one offering still yields many rows — across
 *  categories, fiscal years, quarters and the actuals/target classification — which must be
 *  narrowed by those dimensions before anything is summed. */
export const selectCockpitFinSobRows = createSelector(
  [selectFinancialCockpitState],
  ({ finSobData }) => finSobData
)
